/**
 * @Author: Caroline
 * @Desc: 状态存放
 * @Date: 2021-3-17
 */
import { PAGINATION } from "../service/businessConsts";
import { getMonthStartEnd } from "../filters/filters";

const state = {
  // 用工中心 - 任务列表
  taskList: {
    pageNum: 1,
    pageSize: PAGINATION.pageSize,
    positionName: "",
    positionId: "",
    positionState: "",
    createBeginTime: "",
    createEndTime: ""
  },

  //商户管理 -- 商户列表
  coopList: {
    pageNum: 1,
    pageSize: PAGINATION.pageSize,
    cooperatorName: "",
    cooperatorType: "",
    // upperAgent: "",
    cooperatorId: "",
    batchAgentType: ""
  },

  //数据中心 -- 自由职业者结算统计
  professionalList: {
    pageNum: 1,
    pageSize: PAGINATION.pageSize,
    idNumber: "",
    startTime: getMonthStartEnd()[0],
    endTime: getMonthStartEnd()[1],
    workerAccount: "",
    workerName: "",
    idList: ""
  },

  //数据中心 -- 代理商交易统计
  agentList: {
    pageSize: PAGINATION.pageSize,
    pageNum: 1,
    startTime: "",
    endTime: "",
    cooperatorName: ""
  },

  //数据中心 -- 代理商交易历史统计
  agentHistoryList: {
    pageSize: PAGINATION.pageSize,
    pageNum: 1,
    tradeYear: "2022"
    // occurMonth: "2022-12",
  },

  //数据中心 -- 代理商交易统计详情
  agentDetailList: {
    pageNum: 1,
    pageSize: PAGINATION.pageSize,
    cooperatorId: "",
    startTime: "",
    endTime: "",
    // occurMonth:'',
    sourceCooperatorName: "",
    cooperatorType: ""
  },

  //数据中心 -- 商户结算统计
  merchantSettleList: {
    pageNum: 1,
    pageSize: PAGINATION.pageSize,
    idList: [],
    cooperatorName: "",
    startTime: "",
    endTime: "",
    batchName: ""
  },

  //数据中心 -- 批次明细交易统计
  batchTransDetailList: {
    pageNum: 1,
    pageSize: PAGINATION.pageSize,
    cooperatorIdList: [],
    startDate: "",
    endDate: "",
    workerName: "",
    receiptChannel: "",
    batchName: "",
    distributeStatus: "",
    workerAccount: "",
    idNumber: "",
    distributeId: ""
  },

  // 财务中心 -- 余额管理 - 账单列表
  balanceAccList: {
    subCompanyId: "",
    type: "",
    beginDate: "",
    endDate: "",
    pageNum: 1,
    pageSize: PAGINATION.pageSize
  },

  // 财务中心 -- 充值记录
  rechargeRecordList: {
    pageNum: 1,
    pageSize: PAGINATION.pageSize,
    idList: "",
    beginDate: "",
    endDate: "",
    rechargeStatus: ""
  },

  // 财务中心 -- 电子回单
  electronicInfoList: {
    pageNum: 1,
    pageSize: PAGINATION.pageSize,
    cooperatorIdList: "",
    batchName: "",
    batchState: "",
    startTime: "",
    endTime: "",
    distributeAmountStart: "",
    distributeAmountEnd: "",
    payStartTime: "",
    payEndTime: ""
  },

  // 财务中心 -- 完税证明
  taxProveList: {
    pageNum: 1,
    pageSize: PAGINATION.pageSize,
    overTaxTime: "",
    fileName: ""
  },

  // 财务中心 -- 完税证明 -- 完税详情
  taxProveDetailList: {
    pageNum: 1,
    pageSize: PAGINATION.pageSize,
    idCard: "",
    workerName: "",
    overTaxTime: "",
    distributeCompanyId: ""
  },

  // 财务中心 -- 子账户余额管理
  subsidiaryBalanceList: {
    pageNum: 1,
    pageSize: PAGINATION.pageSize,
    idList: []
  },

  // 财务中心 -- 发票申请
  invoiceApplyList: {
    pageNum: 1,
    pageSize: PAGINATION.pageSize,
    batchName: "",
    invoiceState: "",
    distributeStartDate: "",
    distributeEndDate: "",
    invoiceStartDate: "",
    invoiceEndDate: ""
  },

  // 任务中心 -- 任务中心列表
  taskCenList: {
    pageNum: 1,
    pageSize: PAGINATION.pageSize,
    positionName: "",
    positionId: "",
    positionState: "",
    createBeginTime: "",
    createEndTime: ""
  },

  // 任务中心 -- 任务中心列表 -- 任务中心详情
  taskCenDetailList: {
    positionId: "",
    workerName: "",
    workerMobile: "",
    workerPositionState: "",
    pageNum: 1,
    pageSize: PAGINATION.pageSize
  },

  // 用工中心 - 任务列表 - 报名详情
  taskWokersList: {
    positionId: "",
    workerName: "",
    workerMobile: "",
    workerPositionState: "",
    pageNum: 1,
    pageSize: PAGINATION.pageSize
  },

  // 用工中心 - 用工结算单
  employmentStateList: {
    pageNum: 1,
    pageSize: PAGINATION.pageSize,
    batchName: "",
    batchId: "",
    orderStatus: "",
    startDate: "",
    endDate: ""
  },

  // 用工中心 - 用工结算单 - 提交结算单
  employmentStateSubmitList: {
    pageNum: 1,
    pageSize: PAGINATION.pageSize,
    distributeStatus: "",
    idNumber: ""
  },

  // 用工中心 - 用工结算明细
  employmentStateDescList: {
    pageNum: 1,
    pageSize: PAGINATION.pageSize,
    distributeId: "",
    distributeStatus: "",
    cooperatorIdList: "",
    idNumber: "",
    workerName: "",
    positionName: "",
    startUpdateDate: "",
    endUpdateDate: "",
    startDate: "",
    endDate: "",
    phoneNo: "",
    customNum: "",
    requestNo: "",
    batchName: ""
  },

  // 历史用工结算明细
  historyEmploymentInfoList: {
    pageNum: 1,
    pageSize: PAGINATION.pageSize,
    distributeId: "",
    workerName: "",
    distributeStatus: "",
    batchId: "",
    idNumber: "",
    positionName: "",
    positionId: "",
    phoneNo: "",
    batchName: "",
    tradeYear: "2022",
    payTimeBeginStr: "",
    payTimeEndStr: ""
  },

  // 用工中心 - 自由职业者列表
  professionList: {
    pageNum: 1,
    pageSize: PAGINATION.pageSize,
    workerName: "",
    identNoList: "",
    mobileList: "",
    verifiedStatus: "",
    beginTime: "",
    endTime: "",
    signState: "",
    certificateType: "",
    bankCard: "",
    hochformat: "",
    existIdCardPhoto: "",
    supplementalSignState: "",
    positionName: ""
  },

  // 用工中心 - 结算单风控列表
  riskControlList: {
    pageNum: 1,
    pageSize: PAGINATION.pageSize,
    distributeId: "",
    workerName: "",
    idNumber: "",
    checkState: "",
    settlementStatus: "",
    startDate: "",
    endDate: ""
  },

  // 资金下发管理 - 批次数据准备
  singleBatchDataList: {
    pageNum: 1,
    pageSize: PAGINATION.pageSize,
    cooperatorIdList: [],
    batchName: "",
    batchState: "",
    startDate: "",
    endDate: "",
    fileName: ""
  },

  // 资金下发管理 - 批次数据准备  - 提交
  singleBatchDataSubmitList: {
    pageNum: 1,
    pageSize: PAGINATION.pageSize,
    batchId: "",
    workerName: "",
    idNumber: "",
    distributeStatus: "",
    workerAccount: "",
    distributeAmountStart: "",
    distributeAmountEnd: ""
  },

  // 资金下发管理 - 多批次数据准备
  multiBatchDataList: {
    pageNum: 1,
    pageSize: PAGINATION.pageSize,
    cooperatorIdList: [],
    batchName: "",
    batchState: "",
    startDate: "",
    endDate: "",
    fileName: ""
  },

  // 资金下发管理 - 多批次数据准备 - 提交
  multiBatchDataSubmitList: {
    pageNum: 1,
    pageSize: PAGINATION.pageSize,
    batchId: "",
    workerName: "",
    idNumber: "",
    distributeStatus: "",
    workerAccount: "",
    distributeAmountStart: "",
    distributeAmountEnd: ""
  },

  // 资金下发管理 - 服务费明细列表
  serviceChargeList: {
    pageNum: 1,
    pageSize: PAGINATION.pageSize,
    startTime: "",
    endTime: ""
  },

  // 自由职业者管理 - 自由职业者信息管理
  workersInfoList: {
    pageNum: 1,
    pageSize: PAGINATION.pageSize,
    cooperatorIds: "",
    workerName: "",
    idCard: "",
    createBeginTime: "",
    createEndTime: "",
    verified: ""
  },

  // 自由职业者管理 - 自由职业者签约状态
  workersSignList: {
    cooperatorIds: "",
    workerName: "",
    distributeId: "",
    idCard: "",
    signState: "",
    createBeginTime: "",
    createEndTime: "",
    pageNum: 1,
    pageSize: PAGINATION.pageSize
  },

  // 管理中心 - 账户管理
  accountChildList: {
    pageNum: 1,
    pageSize: PAGINATION.pageSize,
    loginName: "",
    userName: ""
  },

  // 自由职业者管理 -- 个体户信息管理
  indBusinessInfoManageList: {
    pageNum: 1,
    pageSize: PAGINATION.pageSize,
    updateBeginTime: "",
    updateEndTime: "",
    createBeginTime: "",
    createEndTime: "",
    workerName: "",
    idCard: "",
    individualBusinessState: "",
    operatingState: ""
  },

  // 用工中心 - 任务列表 - 任务详情 - 回收站
  recycleBinList: {
    pageNum: 1,
    pageSize: PAGINATION.pageSize,
    workerName: "",
    workerMobile: "",
    workerPositionState: ""
  },

  // 自由职业者管理 -- 个体户订单管理
  perOrderList: {
    pageNum: 1,
    pageSize: PAGINATION.pageSize,
    orderId: "",
    idCard: "",
    startTime: "",
    endTime: "",
    workerName: ""
  },

  // 代开 -- 商户代开统计
  openStatisticList: {
    pageNum: 1,
    pageSize: PAGINATION.pageSize,
    name: "",
    beginDate: "",
    endDate: "",
    personLiableId: ""
  },

  // 保险中心 - 参保明细
  insuranceDetail: {
    pageNum: 1,
    pageSize: PAGINATION.pageSize,
    insuredName: "",
    identNo: "",
    insuredStartTime: "",
    insuredEndTime: "",
    orderId: "",
    overStartTime: "",
    overEndTime: "",
    insuredId: "",
    insuredState: ""
  },

  // 合规中心 - 任务信息维护
  complianceCenter: {
    pageNum: 1,
    pageSize: PAGINATION.pageSize,
    positionName: "",
    positionTypeName: "",
    complianceProgress: ""
  },

  // 财务中心 - 开票记录
  billingRecordList: {
    pageNum: 1,
    pageSize: PAGINATION.pageSize,
    invoiceApprovalId: "",
    applyStartTime: "",
    applyEndTime: "",
    invoiceState: "",
    invoiceVariety: ""
  },

  // 财务中心 - 开票信息管理 - 开票类目列表
  invoiceCategoryList: {
    pageNum: 1,
    pageSize: PAGINATION.pageSize,
    invoiceVariety: ""
  },

  // 数据中心 - 佣金结算订单
  agentBrokerageSettleRecord: {
    pageNum: 1,
    pageSize: PAGINATION.pageSize,
    settlePeriodType: "",
    occurMonth: "",
    occurWeek: "",
    occurDayBegin: "",
    occurDayEnd: ""
  },

  // 用工中心 - 用工花名册
  employmentRoster: {
    ageNum: 1,
    pageSize: PAGINATION.pageSize,
    positionId: "",
    positionName: "",
    workerName: "",
    idCard: "",
    onJob: ""
  },

  // 用工中心 - 测算工具分页
  calculationToolList: {
    pageNum: 1,
    pageSize: PAGINATION.pageSize,
    batchName: "",
    createTimeBegin: "",
    createTimeEnd: "",
    onJob: "",
    scheduleId: ""
  },
};

export default state;



// WEBPACK FOOTER //
// ./src/store/states.js